module.exports = __webpack_public_path__ + "static/media/studio-pro-offer-mobile@3x.f916dccb.png";